<template>
  <div class="main">
    <div style="padding-bottom: 15px; text-align: center; width: 800px; display: none;">
        <span style="font-size: 25px">
          {{formTitle}}
        </span>
    </div>
    <div class="main2">
      <el-form ref="form" :model="form" :rules="rules" label-width="180px" autocomplete="off">
        <el-form-item label="用户名" prop="用户名" size="mini">
          <el-input v-model="form.用户名" ref="用户名" style="width:300px;" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="密码" size="mini">
          <el-input type="password" v-model="form.密码" ref="密码" style="width:300px;" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="重复密码" size="mini">
          <el-input type="password" v-model="form.重复密码" ref="重复密码" style="width:300px;" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <div style="text-align: center;">
          	<el-button ref="sendButton" type="primary" size="mini" @click="submitForm('form')" >{{sendButtonValue}}</el-button>
          	<el-button ref="sendButton2" type="warning" size="mini" @click="close('form')">取消</el-button>
          	
          </div>
        </el-row>
      </el-form>
      </div>
			
  </div>
</template>

<script>
  import * as util from "@/utils/util.js"
	
	export default {
    data() {
			// 重复密码验证
			    const pwdAgainCheck = async(rule, value, callback) => {
			      if (value.length < 1) {
			        return callback(new Error('重复密码不能为空！'));
			      } else if(this.form.密码 != this.form.重复密码){
			        return callback(new Error('两次输入密码不一致！'));
			      }else{
			        callback()
			      }
			    };
      return {
        form: {
          AutoID: '0',
          用户名: '',
					密码: '',
					重复密码: '',
          姓名: '',
					password_rsa: '',
        },
				OldValue:"",
        rules: {
          用户名: [
            {required: true, message: '请输入用户名', trigger: 'blur'}
          ],
          姓名: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          密码: [
					  {required: true, message: '请输入密码', trigger: 'blur'}
					],
					重复密码: [
					  {required: true, validator: pwdAgainCheck, trigger: 'blur'}
					],
					
        },
        sendButtonValue: '保存',
				formTitle: '添加用户',
				type:'',
				id:'0',
				loaded: false,
				
      }
    },
    methods: {
      submitForm(formName) {
				
				//console.log(this.labelList);
				//return;
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            //console.log(JSON.stringify(this.form));
            //alert('submit!');
						this.form.password_rsa=this.$getRsaCode(this.form.密码);
						this.form.密码='';
						this.form.重复密码='';
						
						var url="/Handler/User.ashx?mode=new";
						this.$ajax.post(url,this.form).then((response)=>{
						  //console.log(response.data);
						
						  let value=response.data;
						
						  let errorCode=value.errorCode;
						
						  if(errorCode=="0")
						  {
						    this.$message({
						      type: 'success',
						      message: '保存成功:'
						    });
						    
						    this.$store.dispatch('worktabRemoveNoBack', this.$route.name + '-' + this.$route.params.type);
						    
						    this.$router.push({path: '/user'});
						  }
						  else
						  {
						    let desc=value.desc;
						    this.$alert('保存失败：' +　desc, '系统提示', {
						      confirmButtonText: '确定',
						      callback: action => {
						    
						      }
						    });
						  }
						
						},function(err){
						  console.log(err);
						});

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      close(){
      	this.$store.dispatch('worktabRemoveNoBack', this.$route.name + '-' + this.$route.params.type);
      	
      	this.$router.push({path: '/user'});
      },
      
    },
    mounted(){
			
    }
  }
</script>

<style lang="scss" scoped="scoped">
.sendButton {
	padding-left: 10px;
	padding-right: 10px;
	width: 80px;
}
.main2{
	padding: 10px;
	width: 800px;
	text-align: left;
}

</style>
